import { render, staticRenderFns } from "./AddsCmp.vue?vue&type=template&id=5091d858"
import script from "./AddsCmp.vue?vue&type=script&lang=js"
export * from "./AddsCmp.vue?vue&type=script&lang=js"
import style0 from "./AddsCmp.vue?vue&type=style&index=0&id=5091d858&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5091d858')) {
      api.createRecord('5091d858', component.options)
    } else {
      api.reload('5091d858', component.options)
    }
    module.hot.accept("./AddsCmp.vue?vue&type=template&id=5091d858", function () {
      api.rerender('5091d858', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/automaticSortings/GridManagement/cmp/AddsCmp.vue"
export default component.exports